<div class="contents-area">
  <div class="block-row">
    <div class="column-list">
      <label class="list-input-title">宅配業態</label>
      <div class="list-input-content">
        <app-radio-label name="rbtn_Weekly" #rbtn_Weekly label="ウィークリー" id="rbtn_Weekly"
          [subid]="'rbtn_Weekly'" value="1" [tabindex]="0" [forcedEnabledMode]="'true'"
          [(ngModel)]="kymw7201Model.deliveryDiv">
        </app-radio-label>
        <app-radio-label name="rbtn_Daily" #rbtn_Daily label="デイリー" id="rbtn_Daily"
          [subid]="'rbtn_Daily'" value="2" [tabindex]="0" [forcedEnabledMode]="'true'"
          [(ngModel)]="kymw7201Model.deliveryDiv">
        </app-radio-label>
      </div>
      <label class="list-input-title">注文コード</label>
      <div class="element-row">
        <input type="text" class="text-label-required" #txt_OrderNum plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6"
          [(ngModel)]="kymw7201Model.orderNum" style="width: 70px;">
      </div>
      <label class="list-input-title">利用生協</label>
      <div class="list-input-content">
        <app-checkbox-label #chk_AllSeikyou label="ALL" id="chk_AllSeikyou" [subid]="'chk_AllSeikyou'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw7201Model.allSeikyou"
          (change)="eventChkAllSeikyou_CLICKHandler()"></app-checkbox-label>
        <app-checkbox-label #chk_Ibaraki label="い" id="chk_Ibaraki" [subid]="'chk_Ibaraki'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw7201Model.ibaraki"
          (change)="eventChkSeikyou_CLICKHandler($event)"></app-checkbox-label>
        <app-checkbox-label #chk_Tochigi label="と" id="chk_Tochigi" [subid]="'chk_Tochigi'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw7201Model.tochigi"
          (change)="eventChkSeikyou_CLICKHandler($event)"></app-checkbox-label>
        <app-checkbox-label #chk_Gunma label="ぐ" id="chk_Gunma" [subid]="'chk_Gunma'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw7201Model.gunma"
          (change)="eventChkSeikyou_CLICKHandler($event)"></app-checkbox-label>
        <app-checkbox-label #chk_Chiba label="ち" id="chk_Chiba" [subid]="'chk_Chiba'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw7201Model.chiba"
          (change)="eventChkSeikyou_CLICKHandler($event)"></app-checkbox-label>
        <app-checkbox-label #chk_Saitama label="さ" id="chk_Saitama" [subid]="'chk_Saitama'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw7201Model.saitama"
          (change)="eventChkSeikyou_CLICKHandler($event)"></app-checkbox-label>
        <app-checkbox-label #chk_Tokyo label="とう" id="chk_Tokyo" [subid]="'chk_Tokyo'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw7201Model.tokyo"
          (change)="eventChkSeikyou_CLICKHandler($event)"></app-checkbox-label>
        <app-checkbox-label #chk_Nagano label="な" id="chk_Nagano" [subid]="'chk_Nagano'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw7201Model.nagano"
          (change)="eventChkSeikyou_CLICKHandler($event)"></app-checkbox-label>
        <app-checkbox-label #chk_Niigata label="に" id="chk_Niigata" [subid]="'chk_Niigata'" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw7201Model.niigata"
          (change)="eventChkSeikyou_CLICKHandler($event)"></app-checkbox-label>
      </div>
    </div>
  </div>

  <div [style.width.%]="100">
    <h1>基本情報</h1>
    <div class="block-row">
      <div class="element-column">
        <div class="column-list">
          <label class="list-input-title">運営企画区分</label>
          <div class="list-input-content">
            <app-code-combo-box [required]="true" [codeDiv]="'ctp206'" [labelField]="'codeValueName'"
              [forcedEnabledMode]="'true'" #cmb_PlanningManagementDiv id="cmb_PlanningManagementDiv" [blank]="true" [tabindex]="0"
              [(ngModel)]="kymw7201Model.planningManagementDiv" (change)="cmb_planningManagementDiv_CHANGEHandler()" style="width: 17rem;">
            </app-code-combo-box>
          </div>
          <label class="list-input-title">受注受付開始企画回</label>
          <div class="list-input-content">
            <input type="text" class="text-label-required" #txt_OrderReceptionStartCatalog plessInputTextSub [restrict]="'[0-9]'"
              [(ngModel)]="kymw7201Model.orderReceptionStartCatalog" [maxlength]="8" style="width: 90px;">
            </div>
          <label class="list-input-title">積立増資パターン</label>
          <div class="list-input-content">
            <app-code-combo-box [codeDiv]="'ctp208'" [labelField]="'codeValueName'" [forcedEnabledMode]="'true'"
              #cmb_DepositCapitalIncreasePattern id="cmb_DepositCapitalIncreasePattern" [tabindex]="0"
              [(ngModel)]="kymw7201Model.depositCapitalIncreasePattern"
              (change)="cmb_depositCapitalIncreasePattern_CHANGEHandler()" style="width: 90px;">
            </app-code-combo-box>
          </div>
          <label class="list-input-title">単価</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw7201Model.unitPrice" plessInputTextSub [restrict]="'[0-9]'"
              id="txt_UnitPrice" #txt_UnitPrice [maxlength]="7" style="width: 90px;">
          </div>
          <label class="list-input-title">ポイント数</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw7201Model.pointNumber" plessInputTextSub [restrict]="'[0-9]'"
              id="txt_PointNumber" #txt_PointNumber [maxlength]="7" style="width: 90px;">
          </div>
          <label class="list-input-title">PD区分</label>
          <div class="list-input-content">
            <app-code-combo-box [codeDiv]="'ct028'" [labelField]="'codeValueName'" [(ngModel)]="kymw7201Model.pdDiv"
              id="cmb_PdDiv" #cmb_PdDiv style="width: 17rem;">
            </app-code-combo-box>
          </div>
          <label class="list-input-title">商品名</label>
          <div class="list-input-content">
            <input type="text" class="text-label-required" [(ngModel)]="kymw7201Model.goodsName" [maxlength]="15"
              style="width: 17rem;" #txt_GoodsName plessInputTextSub [fullOnly]="true"
              [restrict]="'[ -￮]'">
          </div>
          <label class="list-input-title">規格名</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw7201Model.standardName" [maxlength]="10" style="width: 12rem;"
              plessInputTextSub #txt_StandardName [fullOnly]="true"
              [restrict]="'[ -￮]'">
          </div>
          <label class="list-input-title">計上部門</label>
          <div class="list-input-content">
            <app-code-combo-box [required]="true" [codeDiv]="'ctp209'" [labelField]="'codeValueName'"
              [(ngModel)]="kymw7201Model.appropriatingClass" id="cmb_AppropriatingClass" #cmb_AppropriatingClass
              style="width: 12rem;">
            </app-code-combo-box>
          </div>
        </div>
      </div>
      <div class="element-column">
        <div class="column-list">
          <label class="list-input-title">運営企画詳細区分</label>
          <div class="list-input-content">
            <app-code-combo-box [codeDiv]="kymw7201Model.setCodeDiv" [labelField]="'codeValueName'"
              [forcedEnabledMode]="'true'" [conReserveNum1]="kymw7201Model.setReserveNum1"
              (change)="planningManagementDetailDiv_CHANGEHandler()" #cmb_PlanningManagementDetailDiv
              id="cmb_PlanningManagementDetailDiv" [tabindex]="0"
              [(ngModel)]="kymw7201Model.planningManagementDetailDiv" style="width: 320px;">
            </app-code-combo-box>
          </div>
          <label class="list-input-title">受注受付終了企画回</label>
          <div class="list-input-content">
            <input type="text" class="text-label-required" #txt_OrderReceptionEndCatalog plessInputTextSub [restrict]="'[0-9]'"
              [(ngModel)]="kymw7201Model.orderReceptionEndCatalog" [maxlength]="8" style="width: 120px;">
          </div>
          <label class="list-input-title">積立増資回数</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw7201Model.depositCapitalIncreaseCount" plessInputTextSub [restrict]="'[0-9]'"
              id="txt_DepositCapitalIncreaseCount" #txt_DepositCapitalIncreaseCount [maxlength]="3" style="width: 60px;">
          </div>
          <label class="list-input-title">帳票チラシコード</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw7201Model.formFlyerCode" id="txt_FormFlyerCode" 
              plessInputTextSub [restrict]="'[a-zA-Z0-9]'" #txt_FormFlyerCode [maxlength]="5" style="width: 60px;">
          </div>
          <label class="list-input-title">休止グループコード</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw7201Model.pauseGroupCode" id="txt_PauseGroupCode"
              plessInputTextSub [restrict]="'[a-zA-Z0-9]'" #txt_PauseGroupCode [maxlength]="1" style="width: 30px;">
          </div>
          <label class="list-input-title">配達リード区分</label>
          <div class="list-input-content">
            <app-code-combo-box [codeDiv]="'ctp212'" [labelField]="'codeValueName'"
              [(ngModel)]="kymw7201Model.deliveryLeadDiv" id="cmb_DeliveryLeadDiv" #cmb_DeliveryLeadDiv
              style="width: 120px;">
            </app-code-combo-box>
          </div>
          <div class="element-row">
            <div class="column-list">
              <label class="list-input-title">商品名(ｶﾅ)</label>
              <div class="list-input-content">
                <input type="text" [(ngModel)]="kymw7201Model.goodsNameKana" [maxlength]="15"
                  style="width: 12rem;" #txt_GoodsNameKana plessInputTextSub [halfOnly]="true" [toUpperCase]="true"
                  (ngModelChange)="eventGoodsNameKana_deleteCommaHandler()">
              </div>
              <label class="list-input-title">規格名(ｶﾅ)</label>
              <div class="list-input-content">
                <input type="text" [(ngModel)]="kymw7201Model.standardNameKana" #txt_StandardNameKana [toUpperCase]="true"
                  [maxlength]="10" style="width: 120px;" plessInputTextSub [halfOnly]="true"
                  (ngModelChange)="eventStandardNameKana_deleteCommaHandler()">
              </div>
            </div>
            <div>
              <label *ngIf="kymw7201Model.planningManagementDiv === '03' && kymw7201Model.operationGoodsId !== ''" class="lbl-special-message">
                お届け明細書のポイント欄の文言変更はシステム依頼が必要です。
              </label>
            </div>
          </div>
        </div>

        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">消費税区分</label>
            <div class="list-input-content" style="width: 120px;">
              <app-code-combo-box [required]="true" [codeDiv]="'ctp210'" [labelField]="'codeValueName'"
                id="cmb_ConsumeTaxDiv" #cmb_ConsumeTaxDiv [forcedEnabledMode]="'true'" [(ngModel)]="kymw7201Model.consumeTaxDiv">
              </app-code-combo-box>
            </div>
          </div>
          <div class="column-list" style="grid-template-columns: 110px 1fr;">
            <label class="list-input-title">消費税率</label>
            <div class="list-input-content" style="width: 50px;">
              <app-code-combo-box [required]="true" [codeDiv]="'ctp211'" id="cmb_ConsumeTaxRate" #cmb_ConsumeTaxRate [forcedEnabledMode]="'true'" [(ngModel)]="kymw7201Model.consumeTaxRate">
              </app-code-combo-box>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button id="btn_back" class="btn-tartiary" #btn_back [tabindex]="0"
    (click)="eventBack_CLICKHandler()">運営商品一覧に戻る</button>
  <button id="btn_Regist" class="btn-secondary" #btn_Regist [tabindex]="0" (click)="eventRegist_CLICKHandler()"
    *ngIf="kymw7201Model.btnRegistDisplay" [disabled]="!kymw7201Model.btnRegistEnabled">登録</button>
  <button id="btn_approval" class="btn-primary" #btn_approval *ngIf="kymw7201Model.btnApprovalDisplay" [tabindex]="0"
    (click)="eventApproval_CLICKHandler()" [disabled]="!kymw7201Model.btnApprovalEnabled">承認</button>
</footer>